module.exports = __webpack_public_path__ + "static/debugging-6a233fbb20d2433a18ef993706c02c54.svg";